import { useCallback } from 'react';

// eslint-disable-next-line no-restricted-imports
import { useDeleteLegalClientBranchMutation } from 'api/generated/graphql';
import { useError } from 'api/helpers';

interface Args {
  id: string;
  reason: string;
  versionNumber: number;
}

export const useDeleteLegalClientBranch = () => {
  const [handle, { loading, error: apolloError }] =
    useDeleteLegalClientBranchMutation();

  const error = useError(apolloError);

  return {
    loading,
    error,
    deleteLegalClientBranch: useCallback(
      async (input: Args) => {
        const res = await handle({ variables: input });
        return res.data?.deleteLegalClientBranch;
      },
      [handle]
    ),
  };
};
